/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2019-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React, {useState, useEffect} from 'react';
import Helmet from 'react-helmet';
import $ from 'jquery';
import {throttle} from 'lodash'
import {Col, Row} from 'react-bootstrap';

import {default as withRouter} from '@corero/ssp-ui-components/utils/withRouter';
import Footer from '@corero/ssp-ui-components/components/app-common/Footer';
import Input from '@corero/ssp-ui-components/components/form/input/Input.js';
import validationRules from '@corero/ssp-ui-components/core/validation.js';
import {actions, store} from '@corero/ssp-ui-components/stores/AuthStore';
import sharedConfig from '@corero/ssp-ui-components/core/sharedConfig';
import {actions as loginActions, store as loginStore} from '@corero/ssp-ui-components/stores/AppConfigStore';
import './login.scss';
import {validated} from "react-custom-validation";
import ServiceUnavailable from "@corero/ssp-ui-components/pages/serviceUnavailable/ServiceUnavailable";


const Login = () => {
    const [fields, setFields] = useState({username: '', password: ''});
    const [title, setTitle] = useState('');
    const [subTitle, setSubTitle] = useState('');
    const [serviceTermUrl, setServiceTermUrl] = useState('');
    const [serviceTermPreText, setServiceTermPreText] = useState('');
    const [linkText, setLinkText] = useState('');
    const [serviceTermPostText, setServiceTermPostText] = useState('');
    const [loginColorText, setLoginColorText] = useState('#FFFFFF');
    const [loginColorButton, setLoginColorButton] = useState('#FFFFFF');
    const [btnForegroundColor, setBtnForegroundColor] = useState('');
    const [loginColorErrorText, setLoginColorErrorText] = useState('');
    const [loginButtonBorderColor, setLoginButtonBorderColor] = useState('');
    const [loginButtonBorderWidth, setLoginButtonBorderWidth] = useState('1');
    const [brandingFlag, setBrandingFlag] = useState(null);
    const [ssoConfig, setSsoConfig] = useState([]);
    const [saml2Config, setSaml2Config] = useState([]);
    const [serviceAvailable, setServiceAvailable] = useState(true);

    const login = () => {
        actions.login(fields);
    };
    const throttledLogin = throttle(login, 2000);

    const onBackendUnavailable = () => {
        setServiceAvailable(false);
    };
    useEffect(() => {
        $("body").addClass("login-page");
        $(".login-page").css("background-image", "url(" + sharedConfig.apis.theme + "/backgroundImage)");
        store.addChangeListener(onChange);
        loginStore.addChangeListener(onLoginConfigIfChange);

        loginActions.fetchThemeConfiguration(onBackendUnavailable);
        loginActions.fetchTermsOfServiceUrlData(onBackendUnavailable);
        loginActions.fetchBrandingFlag(onBackendUnavailable);
        loginActions.fetchSsoLoginConfig(onBackendUnavailable);
        loginActions.fetchSaml2LoginConfig(onBackendUnavailable);
        return () => {
            store.removeChangeListener(onChange);
            loginStore.removeChangeListener(onLoginConfigIfChange)
            $(".login-page").css('background-image', '');
            $(".footer-cr").css('color', '')
            $("body").removeClass("login-page");
        }
    }, []);

    const onLoginConfigIfChange = () => {
        const termsOfServiceData = loginStore.getTermsOfServiceData();
        const splitText = termsOfServiceData && (termsOfServiceData.service_term_text).split(/([{}])/);
        const loginThemeConfig = loginStore.getThemeConfiguration();
        const brandingFlag = loginStore.getBrandingFlag();
        const ssoConfig = loginStore.getSsoLoginConfig();
        const saml2Config = loginStore.getSaml2LoginConfig();
        setTitle(loginThemeConfig.login_title);
        setSubTitle(loginThemeConfig.login_sub_title ? loginThemeConfig.login_sub_title : '');
        setLoginColorText(loginThemeConfig.login_color_text ? loginThemeConfig.login_color_text : '');
        setServiceTermUrl(termsOfServiceData && termsOfServiceData.service_term_url);
        setLinkText(splitText && splitText[2] ? splitText[2] : '');
        setServiceTermPreText(splitText && splitText[0] ? splitText[0] : '');
        setServiceTermPostText(splitText && splitText[4] ? splitText[4] : '');
        setBtnForegroundColor(loginThemeConfig.login_color_btn_foreground ? loginThemeConfig.login_color_btn_foreground : '');
        setLoginColorText(loginThemeConfig.login_color_text ? loginThemeConfig.login_color_text : '');
        setLoginColorButton(loginThemeConfig.login_color_button ? loginThemeConfig.login_color_button : '');
        setLoginButtonBorderColor(loginThemeConfig.login_button_border_color);
        setLoginButtonBorderWidth(loginThemeConfig.login_button_border_width);
        setLoginColorErrorText(loginThemeConfig.login_color_error_text ? loginThemeConfig.login_color_error_text : '');
        setBrandingFlag(brandingFlag);
        setSsoConfig(ssoConfig);
        setSaml2Config(saml2Config);
    };

    useEffect(() => {
        $(".footer-cr").css('color', loginColorText);
        $(".error-message").css('color', loginColorErrorText)
    }, [loginColorText, loginColorErrorText]);

    const onChange = () => {
        const currentStatus = store.getCurrentStatus();
        if (store.isAuth()) {
            window.location.href = window.location.origin + '/';
        } else if(currentStatus.success === false) {
            const loginText = loginStore.getThemeConfiguration();
            const loginColorErrorText = loginText.login_color_error_text ? loginText.login_color_error_text : 'red';
            $(".authentication-error-message").text(currentStatus.message);
            $(".authentication-error-message").css('color', loginColorErrorText);
        }
    };

    const fieldChange = (field, value) => {
        const newFields = { ...fields, [field]: value };
        setFields(newFields);
    };

    const renderLoginPage = () => {
        return (
            <div className="login-container">
                <Helmet defer={false} title="Login"/>
                <div className="login-inner-container">
                    <Row>
                        <Col sm={12}>
                            <Row>
                                <Col sm={{span: 8, offset: 2}} className="text-center">
                                    <img className="logo-frontpage" src={sharedConfig.apis.theme + "/logo-image"}
                                         alt="logo"/>
                                </Col>
                            </Row>

                            <Row className="heading">
                                <Col sm={12} className="text-center">
                                    <div className="header" style={{color: loginColorText}}>{title}</div>
                                    <div className="sub-heading" style={{color: loginColorText}}>{subTitle}</div>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={{span: 4, offset: 4}}>
                                    <ValidatedForm
                                        fields={fields}
                                        onChange={fieldChange}
                                        onValid={throttledLogin}
                                        ssoConfig={ssoConfig}
                                        saml2Config={saml2Config}
                                        loginColorText={loginColorText}
                                        loginColorButton={loginColorButton}
                                        btnForegroundColor={btnForegroundColor}
                                        loginColorErrorText={loginColorErrorText}
                                        loginButtonBorderColor={loginButtonBorderColor}
                                        loginButtonBorderWidth={loginButtonBorderWidth}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                {brandingFlag === true &&
                                    <div className="powered-by-row">
                                        <Col sm={12} style={{color: loginColorText}}
                                             className="text-center">Powered by Corero
                                        </Col>
                                    </div>
                                }
                                <div className="terms-of-service">
                                    <p style={{
                                        color: loginColorText,
                                        textAlign: 'center'
                                    }}>{serviceTermPreText}
                                        <a target="_blank" rel="noreferrer" href={serviceTermUrl} ref={element => {
                                            if (element) element.style.setProperty('color', loginColorText, 'important');
                                        }}><u>{linkText}</u></a>{serviceTermPostText}</p>
                                </div>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <Footer hideVersion/>
            </div>
        )
    };

    const renderServiceUnavailable = () => {
        return (
            <ServiceUnavailable />
        )
    };

    const renderValue = () => {
        if (serviceAvailable) {
            return renderLoginPage();
        } else {
            return renderServiceUnavailable();
        }
    }

    return renderValue();
}


const Form = (props) => {
    const {
        $field, $validation, onChange, onValid, onInvalid, ssoConfig, saml2Config, loginColorText,
        loginColorButton, btnForegroundColor, loginColorErrorText, loginButtonBorderColor, loginButtonBorderWidth
    } = props;
    const fields = {$field, $validation, onChange, fields: props.fields};

    const renderSsoLinks = () => {
        if (ssoConfig.length === 0 && saml2Config.length === 0) {
            return;
        }
        return (
            <Row>
                <Col sm={{span: 4, offset: 4}} className="sso-or-div" ref={element => {
                    if (element) element.style.setProperty('--login-color', loginColorText);
                }}>
                    <p ref={element => {
                        if (element) element.style.setProperty('color', loginColorText, 'important');
                    }}>Or</p>
                </Col>
                {ssoConfig.map((config) => (
                    <Col sm={{span: 8, offset: 2}} className="sso-link" key={config.name}>
                        <a href={`${window.location.origin.toString()}/sso/${config.name}`} ref={element => {
                            if (element) element.style.setProperty('color', loginColorText, 'important');
                        }}>Log in with {config.label}</a>
                    </Col>
                ))}
                {saml2Config.map((config) => (
                    <Col sm={{span: 8, offset: 2}} className="sso-link" key={config.name}>
                        <a href={`${window.location.origin.toString()}/saml2/authenticate/${config.name}`} ref={element => {
                            if (element) element.style.setProperty('color', loginColorText, 'important');
                        }}>Log in with {config.label}</a>
                    </Col>
                ))}
            </Row>)
    };

    return (
        <form onSubmit={(e) => {
            e.preventDefault();
            props.$submit(onValid, onInvalid);
        }} data-testid="login">
            <Row>
                <Col sm={{span: 8, offset: 2}} className="input-field-container">
                    <i className="icon-user_icon"></i>
                    <Input errorColor={loginColorErrorText} type="text" name="username"
                           placeholder="Username" disabled={() => false} autoComplete="off"
                           fieldSizes={{xs: 12}} {...fields} />
                </Col>
            </Row>
            <Row>
                <Col sm={{span: 8, offset: 2}} className="input-field-container">
                    <i className="icon-lock_icon"></i>
                    <Input errorColor={loginColorErrorText} type="password" name="password"
                           placeholder="Password" disabled={() => false} autoComplete="off"
                           fieldSizes={{xs: 12}} {...fields} />
                    <div className="authentication-error-message"></div>
                </Col>
            </Row>
            <Row
                className={`action-link ${(!ssoConfig || !ssoConfig.name) && 'forgot-password-link-no-sso'}`}>
                <Col sm={{span: 8, offset: 2}}>
                    <a href="/login/forgot-password-1" className="forgotten-password" ref={element => {
                        if (element) element.style.setProperty('color', loginColorText, 'important');
                    }}>Forgot Password?</a>
                    <a href="/login/apply-token" className="apply-token" ref={element => {
                        if (element) element.style.setProperty('color', loginColorText, 'important');
                    }}>Apply Password Token</a>
                </Col>
            </Row>
            <Row>
                <Col sm={{ span: 4, offset: 4 }}>
                    <button style={{
                        background: loginColorButton,
                        color: btnForegroundColor,
                        ...(!Number.isNaN(loginButtonBorderWidth) && loginButtonBorderColor && {
                            border: `${loginButtonBorderWidth}px solid ${loginButtonBorderColor}`
                        })
                    }} className="btn btn-primary" type="submit">Log in
                    </button>
                </Col>
            </Row>
            {renderSsoLinks()}
        </form>
    );
}

const userErrMsg = (username, length) => {
    if (username && username.length >= length)
        return null;
    else if (!username)
        return 'A valid username is required';
    else
        return 'This is too short';
};

const passErrMsg = (password, length) => {
    if (password && password.length >= length)
        return null;
    else if (!password)
        return 'Your password is required';
    else
        return 'This is too short';
};

const validationConfig = (props) => {
    const {username, password} = props.fields;

    return {
        fields: ['username', 'password'],

        validations: {
            username: [[userErrMsg, username, 1], [validationRules.maxLength, username, 100, 'Username']],
            password: [[passErrMsg, password, 1]],
        },
    }
}

const ValidatedForm = validated(validationConfig)(Form);


export default withRouter(Login);
